/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-11-23 16:22:22
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-12-12 16:39:23
 * @FilePath: /wemeet-web-activity/src/components/ErrorBoundary/index.tsx
 * @Description: 错误捕获
 */
/** 错误捕获 */
import React from 'react';
import AbnormalState from '@tencent/tpm-meeting-active/lib/AbnormalState';
import '@tencent/tpm-meeting-active/lib/AbnormalState/style';
import { Button } from '@tencent/tea-component';
import { withRouter } from 'next/router';
class ErrorBoundary extends React.Component<any> {
  state = { error: '', showError: '' };
  componentDidCatch(error: Error) {
    const errMsg = JSON.stringify({ msg: error.message, stack: error.stack });
    console.log('boundary', errMsg);
    this.setState({
      showError: window.location.host.indexOf('test') !== -1,
      error: errMsg,
    });
    window?.nextAegis?.infoAll?.(`PageError: ${errMsg}`);
  }
  render() {
    const { error, showError } = this.state;
    if (error) {
      return (
        <AbnormalState
          className="registration-error-page"
          state={'invalid'}
          title={'糟糕，内容已失效～'}
          desc={
            <>
              您所寻找的页面内容已失效，可以点击下方按钮
              {showError && <p>{error}</p>}
              <p>返回上一页</p>
            </>
          }
          operation={
            <Button
              type="primary"
              onClick={() => {
                this.props?.router?.push?.('/home');
              }}
            >
              返回活动空间
            </Button>
          }
        />
      );
    }
    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
